export default __webpack_public_path__ + "static/banner-how-to-stay-safe-when-shopping-online-e9566e361b3a36eb11eca20847da7549.jpg";